import { useApplicationUserContext } from 'context/ApplicationUser';
import { EUserRole } from 'contracts/app-utils/EUserRole';

export default function useUserRole(...rolesToCheck: EUserRole[]) {
    const { user } = useApplicationUserContext();

    return rolesToCheck.includes(user?.role);
}
